import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { useChat } from '~/composables/useChat';
import { IEnvelope, Timetoken } from '~/types/chat';

interface IReactionAction {
  reaction: string;
  color: string;
  icon: string;
  iconInactive: string;
  addLabelPath: string;
  removeLabelPath: string;
}

interface IMessageReaction {
  reaction: string;
  count?: number;
  currentUserReacted?: boolean;
  currentUserActionTimetoken?: Timetoken;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageReactions',
  props: {
    actions: null,
    message: null,
    timetoken: null,
    uuid: null
  },
  setup(__props: any) {

const props = __props as {
  actions?: IEnvelope['actions'];
  message: IEnvelope['message'];
  timetoken: IEnvelope['timetoken'];
  uuid?: IEnvelope['uuid'];
};



const actions: IReactionAction[] = [
  {
    reaction: 'heart',
    icon: 'mdi-heart',
    color: 'accentPurple',
    iconInactive: 'mdi-heart-outline',
    addLabelPath: 'components.chat.messageReactions.heart.add',
    removeLabelPath: 'components.chat.messageReactions.heart.remove',
  },
];

const { pubnub, addReaction, removeReaction } = useChat();
const isReacting = ref(false);

const add = async (reaction: string) => {
  isReacting.value = true;
  await addReaction({ reaction, messageTimetoken: props.timetoken });
  isReacting.value = false;
};

const remove = async (actionTimetoken: Timetoken) => {
  isReacting.value = true;
  await removeReaction({ actionTimetoken, messageTimetoken: props.timetoken });
  isReacting.value = false;
};

const reactions = computed(() => {
  const reactions = Object.entries(props.actions?.reaction || {});
  if (!reactions.length) {
    return {};
  }
  const r: Record<string, IMessageReaction> = {};
  reactions.forEach((reaction) => {
    const userReaction = reaction[1].find((r) => r.uuid === pubnub.getUUID());
    r[reaction[0]] = {
      reaction: reaction[0],
      count: reaction[1].length,
      currentUserReacted: !!userReaction?.actionTimetoken,
      currentUserActionTimetoken:
        userReaction?.actionTimetoken?.toString() || '',
    };
  });
  return r;
});

const handleClick = (reaction: IMessageReaction) => {
  if (reaction?.currentUserReacted && reaction?.currentUserActionTimetoken) {
    remove(reaction.currentUserActionTimetoken);
  } else {
    add(reaction.reaction);
  }
};

return { __sfc: true,props, actions, pubnub, addReaction, removeReaction, isReacting, add, remove, reactions, handleClick }
}

})